export default "__VITE_ASSET__DdSNCY1T__"